<style scoped src="@/lib/font-awesome/css/font-awesome.min.css"></style>
<style scoped src="@/lib/animate/animate.min.css"></style>
<style scoped src="@/lib/ionicons/css/ionicons.min.css"></style>
<style scoped src="@/lib/owlcarousel/assets/owl.carousel.min.css"></style>
<style scoped src="@/lib/lightbox/css/lightbox.min.css"></style> 
<style scoped src="@/css/style.css"></style>


<template>
  <v-app>

<nav class="navbar navbar-b navbar-trans navbar-expand-md fixed-top" id="mainNav"> 
    <div class="container">
      
      <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarDefault"
        aria-controls="navbarDefault" aria-expanded="false" aria-label="Toggle navigation"  v-bind:class="{ 'colorblack': isMenucolor }"  v-on:click="fnShowMenuMobile()">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div class="navbar-collapse collapse justify-content-end" id="navbarDefault"   v-bind:class="{ 'colorblack': isMenucolor }"   >
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link js-scroll"  href="#home">{{ $t('accueil') }} </a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll" href="#about">{{ $t('presentation') }} </a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll" href="#service">{{ $t('services') }} </a>
          </li>

          <li class="nav-item"> 
            <a class="nav-link js-scroll" href="#contact">{{ $t('contact') }} </a>
          </li>
 
        </ul>
      </div>
      <div class="lang-switch">
	<ul>
    <li id="language-fr"  v-bind:class="{ 'active': isFR }">
			<span class="nav-link js-scroll"  v-on:click="fnChangeLanguage('fr')" >FR</span>
		</li>
		<li id="language-en" v-bind:class="{ 'active': isEN }"> 
			<span class="nav-link js-scroll" v-on:click="fnChangeLanguage('en')">EN</span>
		</li>
		<li id="language-ru" v-bind:class="{ 'active': isRU }">
			<span class="nav-link js-scroll" v-on:click="fnChangeLanguage('ru')">RU</span>
		</li>
	</ul>
</div>
    </div>
  </nav>
  <!--/ Nav End /-->

  <!--/ Intro Skew Star /-->
  <div id="home" class="intro route bg-image imageurl" >    
    <div class="overlay-itro"></div>
    <div class="intro-content display-table">
      <div class="table-cell">
        <div class="container">
          <h1 class="intro-title mb-4"> {{ $t('nomprenom') }}</h1><br/>
          <h1 class="intro-title mb-4">{{ $t('titre') }}</h1>
        </div>
      </div>
    </div>
  </div>
  <!--/ Intro Skew End /-->

  <section id="about" class="about-mf sect-pt4 route">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="box-shadow-full">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-sm-6 col-md-5">
                    <div class="about-img">
                      <img src="@/img/testimonial2.jpg" class="img-fluid rounded b-shadow-a" alt="">
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-7">
                    <div class="about-info">
                      <p><span class="title-s">{{ $t('nomprenomtext') }}: </span> <span>{{ $t('nomprenom') }}</span></p>
                      <p><span class="title-s">{{ $t('profiltext') }}: </span> <span>{{ $t('profil') }}</span></p>
                      <p><span class="title-s">{{ $t('emailtext') }}: </span> <span>marc.raymond2@gmail.com</span></p>
                      <p><span class="title-s">{{ $t('telephonetext') }}: </span> <span>+33674293793</span></p>
                    </div>
                  </div>
                </div>
                <div class="skill-mf">
                  <p class="title-s">{{ $t('competencetext') }}</p>
                  <span>HTML</span> 
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="85" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <span>CSS3</span> 
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="75" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <span>SQL (Mysql,Mssql)</span> 
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="75" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <span>PHP (Laravel,Phalcon,php7)</span> 
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="50" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <span>JAVASCRIPT(Angular, VueJS)</span>
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <span>SERVEUR(IIS,Apache,Ngnix)</span>
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="90" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <span>RESEAU(Firewall,Aws)</span>
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 80%" aria-valuenow="90" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                  <span>WINDEV MOBILE</span>
                  <div class="progress">
                    <div class="progress-bar" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0"
                      aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="about-me pt-4 pt-md-0">
                  <div class="title-box-2">
                    <h5 class="title-left">
                      {{ $t('titlepresentation') }}                      
                    </h5>
                  </div>
                  <p class="lead">
                    {{ $t('detailpresentation1') }}
                  </p>
                  <p class="lead">
                    {{ $t('detailpresentation2') }}
                  </p>

                  <p class="lead">
                    {{ $t('moncv') }}
                    <ul>
                    <li><a href="./filecv/MarcRAYMOND_fr.pdf" download="MarcRAYMOND_fr.pdf">FR</a></li>
                    <li><a href="./filecv/MarcRAYMOND_en.pdf" download="MarcRAYMOND_en.pdf">EN</a></li>
                    <li><a href="./filecv/MarcRAYMOND_ru.pdf" download="MarcRAYMOND_ru.pdf">RU</a></li>
                    </ul>
                  </p>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--/ Section Services Star /-->
  <section id="service" class="services-mf route">
    <div class="container" style="margin-top: 65px;">
      <div class="row">
        <div class="col-sm-12">
          <div class="title-box text-center">
            <h3 class="title-a">
               {{ $t('services') }}
            </h3>
            <p class="subtitle-a">
              
            </p>
            <div class="line-mf"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="service-box">
            <div class="service-ico">
              <span class="ico-circle"><i class="ion-network"></i></span>
            </div>
            <div class="service-content">
              <h2 class="s-title">{{ $t('architecturetext') }}</h2>
                {{ $t('architecture') }}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="service-box">
            <div class="service-ico">
              <span class="ico-circle"><i class="ion-code-working"></i></span>
            </div>
            <div class="service-content">
              <h2 class="s-title">{{ $t('webdevtext') }}</h2>
                {{ $t('webdev') }}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="service-box">
            <div class="service-ico">
              <span class="ico-circle"><i class="ion-bug"></i></span>
            </div>
            <div class="service-content">
              <h2 class="s-title">{{ $t('debugtext') }}</h2>
                    
                      {{ $t('debug') }}
              
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="service-box">
            <div class="service-ico">
              <span class="ico-circle"><i class="ion-social-codepen"></i></span>
            </div>
            <div class="service-content">
              <h2 class="s-title">{{ $t('sqltext') }}</h2>
                <p class="s-description text-center">
                  {{ $t('sql') }}
                </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="service-box">
            <div class="service-ico">
              <span class="ico-circle"><i class="ion-paintbrush"></i></span>
            </div>
            <div class="service-content">
              <h2 class="s-title">{{ $t('formationtext') }}</h2>
                <p class="s-description text-center">
                    {{ $t('formation') }}
                </p>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </section>
  <!--/ Section Services End /-->

  <!--/ Section Contact-Footer Star /-->
  <section class="paralax-mf footer-paralax bg-image sect-mt4 route imagebackgroucontacturl" >
    <div class="overlay-mf"></div>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="contact-mf">
            <div id="contact" name="contact" class="box-shadow-full">
              <div class="row">
                <div class="col-md-6">
                  <div class="title-box-2">
                    <h5 class="title-left">
                      {{ $t('sendmessagetitle') }} 
                    </h5>
                  </div>
                  <div>
                    
                      <form class="contactForm"  @submit.prevent="sendEmail" >
                        
                      
                      
                      <div id="errormessage"></div>
                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <div class="form-group">
                            <input required type="text" name="name" v-model="name" class="form-control"  id="name" v-bind:placeholder="$t('formname')" />
                          </div>
                        
                          <div class="form-group">
                            
                            <input required type="email" class="form-control"  v-model="email" name="email" id="email" v-bind:placeholder="$t('formemail')"/>
                            
                          </div>

                            <div class="form-group">
                              <input required type="text" class="form-control"  v-model="subject"  name="subject" id="subject" v-bind:placeholder="$t('formsubject')"  />
                            </div>

                          <div class="form-group">
                            <textarea required  class="form-control" name="message"  v-model="message" rows="5" v-bind:placeholder="$t('formmessage')"></textarea>
                          </div>
                            <div class="form-group">
                            <div id="captcha" name="captcha">
                             </div>
                             <div id="errorcaptachatext" name="errorcaptachatext" v-bind:class="{ 'errorcaptachatextshow': !isCaptchaerror }">
                                {{ $t('errorcaptcha') }}
                             </div>
                            <input type="text" class="form-control" v-model="captchacode"  placeholder="Captcha" id="cpatchaTextBox" name="cpatchaTextBox" v-bind:class="{ 'errorcaptcha': isCaptchaerror }"/> 
                            </div>
                            <div class="form-group">
                              <div id="sendmessage"  v-bind:class="{ 'sendmessageshow': isSendedMessage }"> {{ $t('sendmessage') }} </div>
                            </div>
                            <button  class="button button-a button-big button-rouded"  >{{ $t('sendmessagebtn') }} </button>
                        </div>

                      </div>
                    </form>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="title-box-2 pt-4 pt-md-0">
                    <h5 class="title-left">
                      {{ $t('contacttitle') }} 
                    </h5>
                  </div>
                  <div class="more-info">
                    <p class="lead">
                     {{ $t('textcontact') }}  
                    </p>
                    <ul class="list-ico">
                      <li><span class="ion-ios-location"></span> {{ $t('lieu') }}   </li>
                      <li><span class="ion-ios-telephone"></span>+33674293793</li>
                      <li><span class="ion-email"></span> marc.raymond2@gmail.com</li>
                    </ul>
                  </div>
                  <div class="socials">
                    <ul>


                      <li><a href="https://www.linkedin.com/in/marc-raymond-4720b410/"><span style="padding-top: 5px;" class="ico-circle"><ion-icon name="logo-linkedin"></ion-icon></span></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
  <!--/ Section Contact-footer End /-->

    
  </v-app>
</template>
<script>


import Vue from 'vue'
import BootstrapVue from "bootstrap-vue" 
import VueHead from 'vue-head'
import emailjs from 'emailjs-com';
import * as VeeValidate from "vee-validate";



import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"


Vue.use(VeeValidate);
Vue.use(BootstrapVue)
Vue.use(VueHead)


export default {
 name: 'App',

 methods: {
   sendEmail(e) { 
 
      if (this.captchacode == this.code) {
        const templateParams = {
            name: this.name,
            email: this.email,
            subject: this.subject,
            message: this.message
        };  
        try {
          emailjs.sendForm('service_bf0628f', 'template_nkqayhj', e.target,
          'user_S7bZHRfeLtciTxwub6Ta4', templateParams);
          this.name='';
          this.message='';
          this.email='';
          this.subject='';
          this.isCaptchaerror=0;
          this.isSendedMessage=1;
          this.captchacode='';

        } catch(error) {
           this.isCaptchaerror=1;
           this.createCaptcha();
        }
        
      }else{
        this.isCaptchaerror=1;
        this.createCaptcha();
      }
    },
    createCaptcha : function () {
      //clear the contents of captcha div first 
      document.getElementById('captcha').innerHTML = "";
      let charsArray =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
      let lengthOtp = 6;
      let captcha = [];
      for (var i = 0; i < lengthOtp; i++) {
        //below code will not allow Repetition of Characters
        let index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
        if (captcha.indexOf(charsArray[index]) == -1)
          captcha.push(charsArray[index]);
        else i--;
      }
      let canv = document.createElement("canvas");
      canv.id = "captcha";
      canv.width = 100;
      canv.height = 50;
      let ctx = canv.getContext("2d");
      ctx.font = "25px Georgia";
      ctx.strokeText(captcha.join(""), 0, 30);
      //storing captcha so that can validate you can save it somewhere else according to your specific requirements
      this.code = captcha.join("");
      
      
      document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
    },
    fnChangeLanguage: function (sLanguage) {
      this.$i18n.locale=sLanguage;
      if(sLanguage=='en')
      {
        this.isFR=0;
        this.isEN=1;
        this.isRU=0;
      }
      if(sLanguage=='fr')
      {
        this.isFR=1; 
        this.isEN=0;
        this.isRU=0;
      }
      if(sLanguage=='ru')
      {
        this.isFR=0;
        this.isEN=0;
        this.isRU=1;
      }
    },
     handleScroll () {
        if(window.scrollY > 800){
           this.isMenucolor=1;
        }
        else{
            this.isMenucolor=0;
        }
    },
    fnShowMenuMobile(){
      var element = document.getElementById("navbarDefault");
      element.classList.toggle("show");
    }
    
  },
  components: {
     
  },

  data: () => ({
            name:'',
            email:'',
            message:'',
            subject:'',
            isFR:0,
            isEN:1, 
            isRU:0,
            share_count: 1,
            errors: [],
            code:'', 
            isCaptchaerror:0,
            isMenucolor:0,
            isSendedMessage:0, 
            isShowMenuMobile:0,
            captchacode:'', 
    }),
    created () {
    window.addEventListener('scroll', this.handleScroll);
  },

  mounted(){
    this.createCaptcha();
 },
 head: {
    meta: [
      // creates a meta description tag in header.
      { name: 'description', content: 'Developer Web FullStack Senior PHP,Javascript,SQL' }
    ]
  }
};
</script>